import React, { useState, useEffect } from 'react';

const DeviceModal = ({ isOpen, onClose, onSubmit, apiError, properties, deviceToEdit, devices, initialPropertyId }) => {
    const [serialNumber, setSerialNumber] = useState('');
    const [name, setName] = useState('');
    // CHANGE 1: Set default value here
    const [productName, setProductName] = useState('EN-2815TWE'); 
    const [propertyId, setPropertyId] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [error, setError] = useState('');

    const isEditMode = !!deviceToEdit;

    useEffect(() => {
        if (isOpen) {
            if (isEditMode) {
                setSerialNumber(deviceToEdit.serial_number || '');
                setName(deviceToEdit.name || '');
                // Keep existing value if editing, fallback to default
                setProductName(deviceToEdit.product_name || 'EN-2815TWE'); 
                setPropertyId(deviceToEdit.property_id || '');
                setIsActive(!!deviceToEdit.is_active);
            } else {
                setSerialNumber('');
                setName('');
                // CHANGE 2: Default for new devices
                setProductName('EN-2815TWE'); 
                setPropertyId(initialPropertyId || '');
                setIsActive(true);
            }
            setError('');
        }
    }, [isOpen, deviceToEdit, isEditMode, initialPropertyId]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        if (!serialNumber || !propertyId) {
            setError('Serial Number and Property are required.');
            return;
        }

        const isDuplicate = devices.some(device =>
            device.serial_number.toLowerCase() === serialNumber.toLowerCase() &&
            device.id !== (deviceToEdit ? deviceToEdit.id : null)
        );

        if (isDuplicate) {
            setError('A device with this Serial Number already exists.');
            return;
        }

        onSubmit({
            serial_number: serialNumber,
            name,
            product_name: productName,
            property_id: propertyId,
            is_active: isActive,
        });
    };

    if (!isOpen) return null;
    
    const selectedProperty = properties.find(p => p.id === propertyId);

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>{isEditMode ? 'Edit Device' : 'Add New Device'}</h2>
                <form onSubmit={handleSubmit}>
                    {apiError && <div className="form-error-banner">{apiError}</div>}
                    {error && <div className="form-error-banner">{error}</div>}

                    <div className="form-group">
                        <label className="form-label required" htmlFor="dev-sn">Serial Number</label>
                        <input 
                            id="dev-sn" 
                            type="text" 
                            value={serialNumber} 
                            onChange={e => setSerialNumber(e.target.value)} 
                            className="form-input" 
                            required 
                            placeholder="e.g., E20240063"
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label" htmlFor="dev-model">Device Model</label>
                        <select 
                            id="dev-model" 
                            value={productName} 
                            onChange={e => setProductName(e.target.value)} 
                            className="form-input"
                        >
                            {/* CHANGE 3: Removed empty "Select Model..." option */}
                            <option value="EN-2815TWE">EN-2815TWE (Fingerprint only)</option>
                            <option value="EN-F162FTW">EN-F162FTW (Face + Fingerprint)</option>
                        </select>
                        <small style={{ color: '#64748b', fontSize: '0.8rem', marginTop: '4px', display: 'block' }}>
                            Selecting the correct model enables Face ID features.
                        </small>
                    </div>

                    <div className="form-group">
                        <label className="form-label" htmlFor="dev-name">Device Name (Optional)</label>
                        <input 
                            id="dev-name" 
                            type="text" 
                            value={name} 
                            onChange={e => setName(e.target.value)} 
                            className="form-input" 
                            placeholder="e.g., Front Desk Clock"
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label required" htmlFor="dev-property">Property</label>
                        {isEditMode ? (
                            <select 
                                id="dev-property" 
                                value={propertyId} 
                                onChange={e => setPropertyId(e.target.value)} 
                                disabled={isEditMode} 
                                className="form-input" 
                                required
                            >
                                <option value="">Select a Property...</option>
                                {properties.map(prop => (
                                    <option key={prop.id} value={prop.id}>{prop.name}</option>
                                ))}
                            </select>
                        ) : (
                            <div className="form-input static-field">{selectedProperty?.name}</div>
                        )}
                    </div>

                    <div className="form-group">
                         <label className="form-label">Status</label>
                         <div className="toggle-switch-container">
                             <label className="toggle-switch">
                                <input 
                                    id="dev-active" 
                                    type="checkbox" 
                                    checked={isActive} 
                                    onChange={e => setIsActive(e.target.checked)} 
                                />
                                <span className="slider"></span>
                             </label>
                             <span className="toggle-label">{isActive ? 'Active' : 'Inactive'}</span>
                        </div>
                    </div>

                    <div className="modal-actions">
                        <button type="button" onClick={onClose} className="button button-secondary">Cancel</button>
                        <button type="submit" className="button action-button">Save Device</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DeviceModal;